import { render, staticRenderFns } from "./valueColumn.vue?vue&type=template&id=ba031ee2&"
import script from "./valueColumn.vue?vue&type=script&lang=js&"
export * from "./valueColumn.vue?vue&type=script&lang=js&"
import style0 from "./valueColumn.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports